import { render, staticRenderFns } from "./PartnerInfoCard.vue?vue&type=template&id=2863f716&scoped=true&"
import script from "./PartnerInfoCard.vue?vue&type=script&lang=ts&"
export * from "./PartnerInfoCard.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerInfoCard.vue?vue&type=style&index=0&id=2863f716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2863f716",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
